var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _vm._m(0),
    _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v("\n            " + _vm._s(_vm.warningMessage) + "\n        "),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header md-accent" }, [
      _c("p", [
        _vm._v("\n            No license available for new user\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }